import React from "react";

const Loader = () => (
  <div className="load-spinner-wrapper">
    <div className="load-spinner">Loading...</div>
  </div>
);

export default Loader;
